export default "__VITE_ASSET__KDp$2D8c__"